import { darken } from 'polished';
import { css, type DefaultTheme } from 'styled-components';
import { Z_INDEX } from '../../../styles/layout';
import { agGridCheckboxStyles } from './agGridCheckboxStyles';
import { blotterPopupStyles } from './blotterPopupStyles';

export const agGridPopupChildStyles = (theme: DefaultTheme, background?: string) => css`
  // Make sure the context menu (which is attached to document.body) is visible
  .ag-popup-child {
    z-index: ${Z_INDEX.dropdown};
    ${({ theme }) => blotterPopupStyles(theme)}

    border: none;

    &.ag-menu {
      background: ${({ theme }) => theme.backgroundPopover};
    }

    .ag-menu-option-active {
      background-color: ${({ theme }) => darken(0.03)(theme.backgroundPopover)};
    }

    ${({ theme }) => agGridCheckboxStyles(theme)}

    .ag-column-select {
      background: ${({ theme }) => theme.backgroundPopover};
    }
  }

  [class*='ag-theme-'] {
    --ag-foreground-color: ${theme.colorTextImportant};
    --ag-font-family: ${theme.fontFamily};
  }
`;
